// Ogni parola che il giocatore può leggere, in italiano.
//
// Il file inglese è la fonte di verità: i18n.js ripiega su di esso per ogni chiave
// che qui non è ancora tradotta, quindi una traduzione a metà mostra l'inglese nei
// buchi invece di spazi vuoti o di nomi di chiave.
//
// Le chiavi sono piatte e con i punti di proposito: `ach.veteran.name` si legge allo
// stesso modo in ogni tabella, e una ricerca della chiave trova sia il punto in cui
// viene usata sia la traduzione.

export default {
  // --- chrome --------------------------------------------------------------
  // La descripción que sale en Google y al pegar el enlace en un chat. Vive aquí y no escrita
  // en el HTML porque el HTML se genera por idioma en el build (ver tools/prerender-langs.mjs).
  'seo.description': 'Il classico del lancio di banane, rifatto e multigiocatore: artiglieria a turni su uno skyline al neon. Contro la CPU, sulla stessa tastiera o con un codice. Gratis e in sei lingue.',
  'app.tagline': 'Il classico gioco di lancio di banane, rifatto e multigiocatore.',
  'app.footer': 'Creato da Mendo Network, con amore e molta nostalgia.',
  'ad.label': 'Pubblicità',
  'ad.tag': 'PUBBLICITÀ',
  'app.canvasLabel': 'Campo di battaglia: skyline al neon con due gorilla che lanciano banane',
  'app.language': 'LINGUA',

  'title.start': '▶ GIOCA SUBITO',
  'title.join': '▶ UNISCITI',

  'menu.title': 'MENU PRINCIPALE',
  'menu.resume': '▶ TORNA ALLA PARTITA',
  'menu.newMatch': '▶ NUOVA PARTITA',
  'menu.play': '▶ NUOVA PARTITA',
  'menu.characters': '🎨 PERSONAGGIO',
  'menu.leaderboards': '🏆 CLASSIFICHE',
  'menu.back': '← TORNA ALL-INIZIO',
  'menu.awards': '🏆 OBIETTIVI',

  'setup.title': 'PREPARA LA PARTITA',
  'setup.mode': 'MODALITÀ',
  'setup.players': 'GIOCATORI',
  'setup.turn': 'TEMPO DI TURNO',
  'setup.noLimit': 'SENZA LIMITE',
  'setup.target': 'ROUND DELLA PARTITA',
  'setup.onePlayer': '🤖 1 GIOCATORE',
  'setup.twoPlayers': '👥 2 GIOCATORI',
  'setup.back': '← INDIETRO',
  'setup.start': '▶ INIZIA LA PARTITA',

  'pause.title': 'IN PAUSA',
  'pause.turn': 'TOCCA A {name}',
  'pause.resume': '▶ CONTINUA',
  'pause.restart': '↻ RICOMINCIA',
  'pause.setup': '🎮 IMPOSTAZIONI',
  'pause.share': '🔗 INVITA',
  'pause.home': '🚪 TERMINARE LA PARTITA',
  'pause.menu': '⌂ TORNAR AL MENU PRINCIPALE',
  'pause.music': 'MUSICA',
  'pause.fx': 'EFFETTI',
  'setup.against': 'L’ALTRA PARTE',
  'setup.againstCpu': '🤖 IL COMPUTER',
  'setup.againstRandom': '🎲 AVVERSARIO CASUALE',
  'pool.waiting': '{n} IN ATTESA',
  'pool.playing': '{n} IN PARTITA · {w} IN ATTESA',
  'pool.none': 'ADESSO NON C’È NESSUNO IN ATTESA',
  'pool.noserver': 'NESSUN SERVER · GIOCHERAI CONTRO IL COMPUTER',
  'search.title': 'CERCO UN AVVERSARIO',
  'search.empty': 'LA CODA È VUOTA · GIOCHERAI CONTRO IL COMPUTER',
  'search.seconds': '{n} s',
  'search.matched': '{name} È ARRIVATO',
  'search.cpu': '🤖 GIOCA CONTRO IL COMPUTER',
  'search.cancel': '✖ ANNULLA',
  'special.sheep.name': 'PECORA',
  'special.sheep.hint': 'Salta da sola e poi esplode.',
  'play.fireSheep': '🐑 PECORA!',
  'bubble.sheep': 'BEEE!',
  'char.you': 'TU',
  'char.rival': 'AVVERSARIO',
  'hud.vsOnline': 'VS {name}',
  'music.on': 'MUSICA SÌ',
  'music.off': 'MUSICA NO',
  'pause.button': 'Pausa',

  'results.over': 'PARTITA FINITA',
  'results.wins': 'VINCE {name}',
  'results.rematch': '▶ RIVINCITA',

  // --- the header and the play bar ----------------------------------------
  'hud.vsCpu': 'VS COMPUTER',
  'hud.twoPlayer': '2 GIOCATORI',
  'hud.firstTo': 'VINCE CHI ARRIVA A',
  'hud.round': 'MANCHE {n}',
  'hud.noRound': 'MANCHE —',
  'hud.p1': 'G1',
  'hud.p2': 'G2',
  'hud.cpu': 'CPU',
  'hud.wind': 'VENTO',

  'play.angle': 'ANGOLO',
  'play.power': 'FORZA',
  'play.fire': 'LANCIA',
  'play.waiting': "ASPETTANDO L'AVVERSARIO",
  'play.fireBall': 'LANCIA LA PALLA',
  'play.fireGrenade': 'LANCIA LA GRANATA',
  'play.fireLeap': 'SALTA E LANCIA',
  'play.fireShield': 'ALZA LO SCUDO',
  'play.fireSpring': 'SALI SULLA MOLLA',
  'play.fireMushroom': 'TIENI IL FUNGO',

  // --- the special button --------------------------------------------------
  'special.none': '✦ SPECIALE: NESSUNO',
  'special.spent': '✦ SPECIALE: ESAURITO',
  'special.locked': '✦ SPECIALE: BLOCCATO',
  'special.off': 'NIENTE SPECIAL',
  'special.chosen': '✦ {name} × {n}',

  // --- panels --------------------------------------------------------------
  'loadout.title': '🎒 EQUIPAGGIAMENTO',
  'loadout.note': 'Quello che ti porti dietro: quello che scegli è quello che fa il tuo prossimo tiro, mentre una protezione si alza con il pulsante dello scudo. (Il tasto I apre questo.)',
  'intro.welcome': '{n} ABILITÀ PRONTE — ⚔ ATTACCO NE SCEGLIE UNA',
  'loadout.next': 'Tenuto per il prossimo turno.',
  'loadout.ults': 'ATTACCHI SPECIALI',
  'loadout.guards': 'DIFESE',
  'loadout.howto': 'Obiettivo: {name}',
  'loadout.off': 'Niente attacchi speciali né difese in questa modalità: CLASSICA è il gioco originale.',
  'special.attack': '⚔ ATTACCO',
  'special.guard': '🛡 DIFESA',
  'announce.round': 'MANCHE {n}',
  'announce.fight': 'SI COMINCIA!',
  'announce.turn': 'TOCCA A TE — {name}',
  'splash.tapForMusic': 'TOCCA PER SENTIRE LA MUSICA',
  'char.title': '🎨 PERSONAGGI',
  'char.close': '✕ CHIUDI',
  'char.save': '✓ SALVA',
  'char.note': 'Specie e accessori. Un animale più largo è un bersaglio più largo, e un cilindro è una testa un po’ più grande: il disegno è la zona dei colpi.',
  'char.player1': 'GIOCATORE 1',
  'char.player2': 'GIOCATORE 2',
  'slot.hat': 'CAPPELLO',
  'slot.face': 'VISO',
  'slot.neck': 'COLLO',

  'award.title': '🏆 OBIETTIVI',
  'award.close': '✕ CHIUDI',
  'award.progress': '🏆 OBIETTIVI {n}/{total}',
  'award.rewardAntic': '+ GESTO {name}',
  'award.rewardSpecial': '+ SPECIALE {name}',

  'rank.title': '🏆 CLASSIFICHE',
  'rank.close': '✕ CHIUDI',
  'rank.name': 'IL TUO NICKNAME',
    'rank.namePlaceholder': 'Scrivi qui il tuo nick per giocare',
  'rank.online': 'ONLINE — MIGLIORI PER PRIMI',
  'rank.refresh': '↻ AGGIORNA',
  'rank.local': 'SU QUESTA MACCHINA',
  'rank.emptyLocal': 'Ancora niente. Finisci una partita e finirà qui.',
  'rank.emptyOnline': 'La classifica è ancora vuota. Sii il primo.',
  'rank.checking': 'Controllo…',

  'share.close': 'CHIUDI',
  'share.generate': 'INVITA A UNA PARTITA',
  'share.placeholder': 'Il tuo codice comparirà qui',
  'share.copied': 'Copiato. Mandalo a chi vuoi invitare.',
  'join.placeholder': 'HO UN CODICE',
  'join.title': 'UNISCITI A UNA PARTITA',
  'join.label': 'Codice della partita',

  'lang.title': 'LINGUA',
  'lang.note': 'L’inglese è l’originale. Tutto il resto è una traduzione.',

  // --- shared match codes --------------------------------------------------
  'code.noCode': 'Incolla prima un codice.',
  'code.tooLong': 'È decisamente troppo lungo per essere un codice di partita.',
  'code.notACode': 'Non sembra un codice di partita.',
  'code.version': 'Quel codice viene da un’altra versione.',
  'code.corrupt': 'Codice corrotto.',
  'code.mode': 'Quel codice indica una modalità che questa versione non ha.',

  // --- the shared board ----------------------------------------------------
  'lb.checking': 'sto chiedendo al server…',
  'lb.online': 'classifica condivisa, in diretta',
  'lb.noServer': 'qui non c’è un server di classifica',
  'lb.timeout': 'il server non ha risposto in tempo',

  // --- what the gorillas shout --------------------------------------------
  'bubble.fireInTheHole': 'ATTENTI SOTTO!',
  'bubble.leap': 'FACCIO STRADA!',
  'bubble.uavOnline': 'DRONE NEMICO IN VOLO',
  'bubble.headshot': 'BOOM, IN PIENO!',
  'bubble.extraLife': 'VITA EXTRA!',
  'bubble.mushroomSaved': 'IL FUNGO HA RETTO!',
  'bubble.boomerangBack': 'È TORNATO!',
  'bubble.boomerangLost': 'NON È TORNATO',

  // --- the caption after a kill -------------------------------------------
  'wasted.subtitle': 'Al vento non importa dei tuoi piani.',

  // --- the sky -------------------------------------------------------------
  'banner.0': 'MANGIA PIÙ BANANE',
  'banner.1': 'SCATENA LA SCIMMIA!',
  'banner.2': 'UNA BANANA PRESIDENTE',
  'banner.3': 'QUESTO STRISCIONE MENTE',
  'banner.4': 'SPEDITE BANANE',
  'banner.5': 'MI HAI MANCATO ANCORA',
  'banner.6': 'ABBRACCI GRATIS',
  'banner.7': 'AIUTO, SONO IN UN VIDEOGIOCO',
  'banner.8': 'VICE CITY — A 4 MINUTI',
  'banner.9': 'LEONIDA: L’ALTRA FLORIDA',
  'banner.10': 'IN ARRIVO NEL 2027. FORSE.',

  // --- the splash ----------------------------------------------------------
  'tip.0': 'CONSIGLIO: AL VENTO NON IMPORTANO I TUOI PIANI.',
  'tip.1': 'CONSIGLIO: L’ANTEPRIMA NON CONTA MAI IL VENTO. È PROPRIO QUELLO IL PUNTO.',
  'tip.2': 'CONSIGLIO: UNA BANANA CHE TORNA GIÙ È SEMPRE UNA BANANA.',
  'tip.3': 'CONSIGLIO: UNA GRANATA NON HA BISOGNO DI COLPIRE NESSUNO.',
  'tip.4': 'CONSIGLIO: SE L’ALTRO GORILLA DORME, SPARA.',
  'tip.5': 'CONSIGLIO: QUALCUNO DOVRÀ PULIRE QUELLO SKYLINE.',

  // --- species -------------------------------------------------------------
  'species.gorilla': 'GORILLA',
  'species.chimp': 'SCIMPANZÈ',
  'species.orangutan': 'ORANGOTANGO',
  'species.baboon': 'BABBUINO',
  'species.panda': 'PANDA',
  'species.bear': 'ORSO BRUNO',
  'species.rhino': 'RINOCERONTE',
  'species.bonobo': 'BONOBO',
  'species.gibbon': 'GIBBONE',
  'species.mandrill': 'MANDRILLO',
  'species.hippo': 'IPPOPOTAMO',
  'species.duck': 'ANATRA',
  'species.frog': 'RANA',

  // --- accessories ---------------------------------------------------------
  'accessory.cap': 'CAPPELLINO',
  'accessory.beanie': 'BERETTO',
  'accessory.tophat': 'CILINDRO',
  'accessory.crown': 'CORONA',
  'accessory.viking': 'ELMO VICHINGO',
  'accessory.bow': 'FIOCCO ROSA',
  'accessory.shades': 'OCCHIALI SCURI',
  'accessory.patch': 'BENDA SULL’OCCHIO',
  'accessory.scarf': 'SCIARPA',
  'accessory.bowtie': 'PAPILLON',
  'accessory.chain': 'CATENA D’ORO',

  // --- gestures ------------------------------------------------------------
  'antic.scratch': 'GRATTATA',
  'antic.head': 'GRATTATA IN TESTA',
  'antic.chest': 'PETTI COLPI',
  'antic.wave': 'SALUTO',
  'antic.pick': 'DITO NEL NASO',
  'antic.shrug': 'SPALLUCCE',
  'antic.stretch': 'STIRAMENTO',
  'antic.shake': 'SCROLLATA',
  'antic.clap': 'APPLAUDE',
  'antic.flex': 'MOSTRA I MUSCOLI',

  // --- modes ---------------------------------------------------------------
  'mode.modern.name': 'MODERNA',
  'mode.modern.blurb': 'Speciali, gesti, cielo e obiettivi.',
  'mode.classic.name': 'CLASSICA',
  'mode.classic.blurb': 'Niente speciali, gesti, cielo né obiettivi.',
  'mode.demolition.name': 'DEMOLIZIONE',
  'mode.demolition.blurb': 'Cratere che tirano giù un palazzo intero.',
  'mode.lunar.name': 'GRAVITÀ LUNARE',
  'mode.lunar.blurb': 'Un terzo della forza.',
  'mode.weather.name': 'MALTEMPO',
  'mode.weather.blurb': 'Pioggia, neve e raffiche.',
  'mode.quake.name': 'TERREMOTO',
  'mode.quake.blurb': 'I palazzi salgono e scendono sotto i piedi.',

  // --- specials ------------------------------------------------------------
  'special.flare.name': 'RAZZO',
  'special.flare.hint': 'L’anteprima arriva al doppio.',
  'special.heavy.name': 'PESANTE',
  'special.heavy.hint': 'Il vento quasi non la muove.',
  'special.fat.name': 'CARICO LARGO',
  'special.fat.hint': 'Un cratere molto più grande.',
  'special.lunar.name': 'LUNARE',
  'special.lunar.hint': 'Niente vento. Cratere enorme.',
  'special.grenade.name': 'GRANATA',
  'special.grenade.hint': 'Rimbalza e scoppia a tempo.',
  'special.drone.name': 'DRONE',
  'special.drone.hint': 'Volta sopra e lo segnala.',
  'special.leap.name': 'IL SALTO',
  'special.leap.hint': 'Salta dove sta l’avversario.',
  'special.shield.name': 'SCUDO',
  'special.shield.hint': 'Ferma un colpo dell’avversario.',
  'social.title': 'DILLO A QUALCUNO',
  'social.whatsapp': 'Condividi su WhatsApp',
  'social.telegram': 'Condividi su Telegram',
  'social.facebook': 'Condividi su Facebook',
  'social.x': 'Condividi su X',
  'social.instagram': 'Manda su Instagram — apre il menù di condivisione del telefono',
  'social.copy': 'Copia il link',
  'toast.copied': '🔗 Link copiato',
  'toast.copyFailed': 'Il browser non me l’ha lasciato copiare',
  'special.pick': 'SCEGLINE UNO',
  'special.spring.name': 'MOLLA',
  'special.spring.hint': 'Sali e ballaci sopra.',
  'special.mushroom.name': 'FUNGO',
  'special.mushroom.hint': 'Si prende il colpo che ti ucciderebbe.',

  'toast.crateSpecial': '📦 {name} +1 — tuo anche la prossima manche',
  'toast.crateTheirs': '📦 {who} prende {name}',
  'toast.crateLife': '❤ VITA EXTRA — resisti un colpo in più',
  'toast.crateLifeTheirs': '❤ {who} si prende una vita extra',
  'toast.award': '🏆 OBIETTIVO! {names}',
  'setup.cpu': 'DIFFICOLTÀ DEL COMPUTER',
  'setup.cpuEasy': 'FACILE',
  'setup.cpuNormal': 'NORMALE',
  'setup.cpuHard': 'DIFFICILE',
  'rotate.title': 'GIRA IL TELEFONO',
    'rotate.body': 'La partita si gioca di lato: gira il telefono per continuare.',
  'setup.duel': 'COME GIOCATE IN DUE',
  'duel.code': '🔗 UNO SU PC / TELEFONO',
  'duel.hotseat': '⌨️ STESSO COMPUTER',
  'share.waiting': 'Mandagli il codice. Te ne rimanda un altro.',
  'share.invite': 'Copia il codice e mandalo a chi vuoi invitare.',
  'share.joined': 'Sei dentro. Giochi tu per primo.',
  'share.roomOpen': 'La stanza è aperta: con questo codice si entra e si gioca in diretta, senza passarsi codici.',
  'share.roomBack': 'Il tuo rivale è dentro.',
  'share.roomGone': 'Il tuo rivale è uscito. La stanza resta aperta e il suo posto è libero.',
  'share.roomLost': 'È caduta la connessione. La partita continua su questo dispositivo.',
  'code.inviteLength': 'Un codice d’invito ha 8 caratteri, 4 e 4.',
  'code.inviteLetters': 'Quel codice ha un carattere che non può starci.',
  'code.inviteCheck': 'Quel codice non torna: controlla una lettera.',
  'special.ball.name': 'LA PALLA',
  'special.ball.hint': 'A volte è una palla.',
  'special.boomerang.name': 'BOOMERANG',
  'special.boomerang.hint': 'Torna in mano tua e non consuma la carica.',
  'toast.ball': '{icon} {name}!',
  'ball.basket': 'PALLA DA BASKET',
  'ball.football': 'PALLA DA CALCIO',
  'ball.rugby': 'PALLA OVALE',
  'ball.tennis': 'PALLA DA TENNIS',

  // --- achievements --------------------------------------------------------
  'ach.first-blood.name': 'PRIMO SANGUE',
  'ach.first-blood.hint': 'Centra la tua prima banana.',
  'ach.round-won.name': 'MANCHE VINTA',
  'ach.round-won.hint': 'Vinci una manche.',
  'ach.butterfingers.name': 'MANI DI BURRO',
  'ach.butterfingers.hint': 'Colpire te stesso vale lo stesso.',
  'ach.sharpshooter.name': 'TIRATORE SCELTO',
  'ach.sharpshooter.hint': 'Centra tre colpi di fila.',
  'ach.match-won.name': 'PARTITA VINTA',
  'ach.match-won.hint': 'Vinci una partita.',
  'ach.cpu-slayer.name': 'MACELLO DI CPU',
  'ach.cpu-slayer.hint': 'Vinci una partita contro il computer.',
  'ach.moon-shot.name': 'TIRO LUNARE',
  'ach.moon-shot.hint': 'Fai passare una banana davanti alla luna.',
  'ach.sky-watcher.name': 'GUARDA IL CIELO',
  'ach.sky-watcher.hint': 'Becca tre cose diverse che attraversano il cielo.',
  'ach.flawless.name': 'IMMACOLATO',
  'ach.flawless.hint': 'Vinci una partita senza perdere una sola manche.',
  'ach.veteran.name': 'VETERANO',
  'ach.veteran.hint': 'Vinci tre partite.',
  'ach.thrower.name': 'LANCIATORE',
  'ach.thrower.hint': 'Lancia 50 banane.',
  'ach.rounds-10.name': 'DIECI MANCHE',
  'ach.rounds-10.hint': 'Vinci dieci manche.',
  'ach.sharpshooter-plus.name': 'OCCHIO DI FALCO',
  'ach.sharpshooter-plus.hint': 'Centra sei colpi di fila.',
  'ach.moon-3.name': 'ASTROFISICO',
  'ach.moon-3.hint': 'Passa tre volte davanti alla luna con una banana.',
  'ach.cpu-3.name': 'SCATENATO',
  'ach.cpu-3.hint': 'Batti il computer tre volte.',
  'ach.flawless-3.name': 'INTOCCABILE',
  'ach.flawless-3.hint': 'Vinci tre partite senza perdere una manche.',
  'ach.veteran-2.name': 'LEGGENDA',
  'ach.veteran-2.hint': 'Vinci cinque partite.',
  'ach.scavenger.name': 'SCIACALLO',
  'ach.scavenger.hint': 'Apri cinque casse.',
  'ach.wall.name': 'IL MURO',
  'ach.wall.hint': 'Alza lo scudo cinque volte.',
  'ach.arsenal.name': 'ARSENALE',
  'ach.arsenal.hint': 'Usa sei speciali diversi.',
  'ach.bare-handed.name': 'A MANI NUDE',
  'ach.bare-handed.hint': 'Vinci una partita senza spendere niente.',
  'ach.room-won.name': 'IN DIRETTA',
  'ach.room-won.hint': 'Vinci una partita in una stanza.',
  'ach.room-3.name': 'QUARTIERE',
  'ach.room-3.hint': 'Vinci tre partite nelle stanze.',
  'ach.by-mail.name': 'PER POSTA',
  'ach.by-mail.hint': 'Vinci un duello con il codice.',
  'ach.boomerang-back.name': 'IL RITORNO',
  'ach.boomerang-back.hint': 'Riprendi il tuo boomerang tre volte.',
};
